import React, {useState} from 'react';
import './board.scss';

import PLACE_HOLDER_IMAGE from "assets/about/place_holder_image.png"

export const Board = () => {
    const [board] = useState<Array<{ title: string, name: string, image: any }>>([
        {name: "MICHAEL LECKIE", title: "President", image: PLACE_HOLDER_IMAGE},
        {name: "HUGH JOHNSON", title: "Immediate Past President", image: PLACE_HOLDER_IMAGE},
        {name: "NORMAN GRANT", title: "1st Vice President", image: PLACE_HOLDER_IMAGE},
        {name: "GARNETT REID", title: "2nd Vice President", image: PLACE_HOLDER_IMAGE},
        {name: "WAYNE LEWIS", title: "Treasurer", image: PLACE_HOLDER_IMAGE},
        {name: "CHERYL CROOKS", title: "Assistant Treasurer", image: PLACE_HOLDER_IMAGE},
        {name: "DOLLIS CAMPBELL", title: "Secretary", image: PLACE_HOLDER_IMAGE},
        {name: "BRIDGETTE STEELE", title: "Director", image: PLACE_HOLDER_IMAGE},
        {name: "DIANNA DAVIS-SMITH", title: "Director", image: PLACE_HOLDER_IMAGE},
        {name: "FRED MANDERSON", title: "Director", image: PLACE_HOLDER_IMAGE},
        {name: "DESMOND WILLIAMS", title: "Director", image: PLACE_HOLDER_IMAGE},
        {name: "OPAL LEVY", title: "Director", image: PLACE_HOLDER_IMAGE},
        {name: "DONOVAN WIGNAL", title: "Director", image: PLACE_HOLDER_IMAGE},
    ])
    return (
        <div className={'board'}>
            <div className={'board_wrapper'}>
                <h1>Our Board</h1>
                <div className="board_wrapper_items">
                    {
                        board.map(({name, title, image}, index) => (
                            <div key={"board" + name + index} className="board_wrapper_items_item">
                                <img src={image} alt=""/>
                                <div className={'board_wrapper_items_item_info'}>
                                    <h2>{name}</h2>
                                    <span>{title}</span>
                                </div>

                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    );
};

export default Board;
